import React, { useContext, useState } from 'react'
import styled from 'styled-components'

import DeleteTaskButton from '~/components/tasks/tasksList/DeleteTaskButton'
import TaskMenu from '~/components/tasks/tasksList/TaskMenu'
import FlexContainer from '~/components/common/FlexContainer'

import tasksContext from '~/contexts/tasks/tasksContext'

import colors from '~/styles/colors'
import { radius } from '~/styles/vars'
import useClickOutside from '~/hooks/useClickOutside'

interface Props {
    label: string
    done: boolean
    id: string
}

const Task: React.FC<Props> = ({ label, done, id }) => {
    const [isEditing, setIsEditing] = useState(false)
    const [labelValue, setLabelValue] = useState(label)
    const { dispatch } = useContext(tasksContext)

    const inputRef = useClickOutside(() => {
        setIsEditing(false)
    })

    const handleClick = (event: React.MouseEvent | React.ChangeEvent) => {
        event.stopPropagation()
        dispatch({ type: 'invert_done_value', data: { id } })
    }

    const handleIsEditing = () => setIsEditing(!isEditing)

    const handleEditLabel = (event: any) => {
        console.log(event)
        setLabelValue(event.target.value)
    }

    const handleLabelSubmit = async (event: any) => {
        event.preventDefault()
        event.stopPropagation()
        if (!label) return
        await dispatch({ type: 'rename_task', data: { id, label: labelValue } })
        handleIsEditing()
    }
    return (
        <Container onClick={handleClick} done={done}>
            {console.log('render: ' + label + '   value : ' + labelValue)}
            <SubContainer>
                <CheckBox
                    type="checkbox"
                    checked={done}
                    onClick={handleClick}
                    onChange={() => false}
                />
                {isEditing ? (
                    <form onSubmit={handleLabelSubmit}>
                        <EditInput
                            ref={inputRef}
                            name="label"
                            value={labelValue}
                            onChange={handleEditLabel}
                            onClick={e => e.stopPropagation()}
                            onBlur={() => setIsEditing(false)}
                            autoFocus
                        />
                        {/* <SubmitButton done={done} onClick={handleLabelSubmit}>Valider</SubmitButton> */}
                    </form>
                ) : (
                    <Label done={done} onClick={handleClick}>
                        {label}
                    </Label>
                )}
            </SubContainer>
            <FlexContainer>
                <TaskMenu handleIsEditing={handleIsEditing} />
                <DeleteTaskButton id={id} />
            </FlexContainer>
        </Container>
    )
}

const EditInput = styled.input`
    font-size: 1.8rem;
    border: 2px solid ${colors.main[300]};
    outline: none;
    box-shadow: none;
    width: 30vw;
    color: ${colors.accent[500]};
    background-color: transparent;
    padding: 1rem 0.75rem;
    border-radius: ${radius.sm};
    @media (max-width: 476px) {
        width: 45vw;
    }
`

interface LabelProps {
    done: boolean
}

interface ContainerProps extends LabelProps {}
interface ButtonProps extends LabelProps {}

const Label = styled.p<LabelProps>`
    color: ${({ done }) => (done ? colors.main[300] : colors.accent[500])};
    text-decoration: ${({ done }) => (done ? 'line-through' : 'none')};
    cursor: pointer;
    text-overflow: ellipsis;
    user-select: none;
    cursor: pointer;
    word-wrap: break-word;
    text-align: center;
`

const SubContainer = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    cursor: pointer;
    min-width: 25%;
    padding: 1rem;
    overflow: hidden;
`

const Container = styled.div<ContainerProps>`
    background-color: ${props => (props.done ? colors.main[700] : colors.main[600])};
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0.5rem auto;
    width: 80%;
    padding: 1.25rem 1rem;
    border: 2px solid ${props => (props.done ? colors.main[600] : colors.main[300])};
    border-radius: ${radius.sm};
    @media (max-width: 480px) {
        width: 100%;
    }
`

const CheckBox = styled.input`
    border-radius: 50%;
    padding: 1rem;
    min-width: 2rem;
    min-height: 2rem;
    margin-right: 2rem;
`

const SubmitButton = styled.button<ButtonProps>`
    margin-left: 1rem;
    color: ${colors.accent[500]};
	border: 1px solid ${colors.accent[500]};
    border-radius: ${radius.sm};
    background: ${props => (props.done ? colors.main[700] : colors.main[600])};
	padding: 1rem;
    height: 100%;
    cursor: pointer;
    font-size: inherit;
    :hover {
        background-color: ${colors.accent[500]};
        color: white;
    }
`

export default Task
